import { t } from '@lingui/macro';

export const weekDayList = [
  {
    id: 0,
    name: t`Sunday`,
  },
  {
    id: 1,
    name: t`Monday`,
  },
  {
    id: 2,
    name: t`Tuesday`,
  },
  {
    id: 3,
    name: t`Wednesday`,
  },
  {
    id: 4,
    name: t`Thursday`,
  },
  {
    id: 5,
    name: t`Friday`,
  },
  {
    id: 6,
    name: t`Saturday`,
  },
];
